import { TokenResponse } from "./Responses/TokenResponse.ts";
import { sellerApiClient } from "./apiClient/sellerApiClient";

export const getToken = async (
  userName: string,
  password: string,
): Promise<TokenResponse> => {
  const response = await sellerApiClient.post<TokenResponse>(
    "v1/auth/token",
    {
      clientId: "sellers-dashboard-webui",
      activitySource: "WebInterface",
      userName,
      password,
    },
  );

  response.data.received_at = new Date().getTime();

  return response.data;
};

export const refreshToken = async (
  refreshToken: string,
): Promise<TokenResponse> => {
  try {
    const response = await sellerApiClient.post<TokenResponse>(
      "v1/auth/token/refresh",
      {
        clientId: "sellers-dashboard-webui",
        activitySource: "WebInterface",
        refreshToken,
      },
    );
    response.data.received_at = new Date().getTime();
    return response.data;
  } catch (error) {
    console.error("Ошибка при обновлении токена:", error);
    throw error;
  }
};

//dd
